import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, CircularProgress } from '@mui/material';
import { joinOrg } from '../API/User';
import { AlertContext } from '../App/App';
import GroupIcon from '@mui/icons-material/Group';

export const JoinOrg = ({ userProfile }) => {
    const { orgId } = useParams();
    const navigate = useNavigate();
    const { setSystemAlert } = useContext(AlertContext);
    const [loading, setLoading] = useState(false);
    const [joined, setJoined] = useState(false);
    const [error, setError] = useState(null);

    const handleJoin = async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await joinOrg(orgId);
            if (result?.status === 200) {
                setJoined(true);
                setSystemAlert({ msg: `Joined ${result.orgName}!`, type: 'success', duration: 3000 });
            } else {
                setError(result?.error || 'Failed to join organization');
            }
        } catch (err) {
            setError('Failed to join organization');
        } finally {
            setLoading(false);
        }
    };

    if (!userProfile?.email) {
        return (
            <Container maxWidth="sm">
                <Box sx={{ mt: 8, textAlign: 'center' }}>
                    <GroupIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h5" gutterBottom>
                        Join Organization
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        Please log in to join this organization.
                    </Typography>
                    <Button variant="contained" onClick={() => navigate('/')}>
                        Go to Login
                    </Button>
                </Box>
            </Container>
        );
    }

    if (joined) {
        return (
            <Container maxWidth="sm">
                <Box sx={{ mt: 8, textAlign: 'center' }}>
                    <GroupIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
                    <Typography variant="h5" gutterBottom>
                        Successfully Joined!
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        You are now a member of the organization.
                    </Typography>
                    <Button variant="contained" onClick={() => navigate('/profile')}>
                        Go to Profile
                    </Button>
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm">
            <Box sx={{ mt: 8, textAlign: 'center' }}>
                <GroupIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom>
                    Join Organization
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                    You've been invited to join an organization.
                </Typography>

                {error && (
                    <Typography color="error" sx={{ mb: 2 }}>
                        {error}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    size="large"
                    onClick={handleJoin}
                    disabled={loading}
                    sx={{ minWidth: 200 }}
                >
                    {loading ? <CircularProgress size={24} /> : 'Join Organization'}
                </Button>
            </Box>
        </Container>
    );
};
